import { MapTo } from '@adobe/aem-react-editable-components';
import ApplicationStatusForm, { ApplicationStatusFormEditConfig } from './ApplicationStatusForm';

export default MapTo('cob-corp-acquisition/components/creditonebank/application-status-form')(ApplicationStatusForm, ApplicationStatusFormEditConfig);